import { useState } from "react";

import { useTranslation } from "react-i18next";

import { useTableStoreByRoute } from "@/stores/useTableStore";

import { ALERT_STATUS } from "../../../../context/alert/types";
import { DRIVERS_ACTIONS, ROUTES, VEHICLES_ACTIONS } from "../../../../shared";
import { refreshTableAndUpdateDetails } from "../../../../shared/functions/functions";
import useTableItemDetails from "../../../DetailsSection/hooks/useTableItemDetails";
import { ResourceParams } from "../../../Schedules/types";
import { Actions } from "../types";

interface UseSchedulesMainDialogProps {
  route: ROUTES;
  resourceCount: number;
  isTutorialOpen: boolean;
  onClose: (action: Actions) => void;
  actionMain: VEHICLES_ACTIONS | DRIVERS_ACTIONS;
  resourceParams: ResourceParams;
  handleResponse: (
    status: ALERT_STATUS,
    message: string,
    description?: string,
  ) => any;
}

const useSchedulesMainDialog = ({
  route,
  resourceCount,
  isTutorialOpen,
  onClose,
  actionMain,
  resourceParams,
  handleResponse,
}: UseSchedulesMainDialogProps) => {
  const { getTableItemDetails } = useTableItemDetails();
  const { t } = useTranslation();

  const {
    detailsData,
    params: { contains: valueInSearchField },
  } = useTableStoreByRoute(route);

  const [isCloseDialogConfirmationOpen, setIsCloseDialogConfirmationOpen] =
    useState(false);

  const handleCloseSchedulesMainDialog = () => {
    if (resourceCount === 0 || isTutorialOpen) {
      onClose(actionMain);
    } else {
      setIsCloseDialogConfirmationOpen(true);
    }
  };

  const handleConfirmCloseDialog = (
    closeVehicleSchedules: boolean,
    closeConfirmOnly: boolean,
  ) => {
    setIsCloseDialogConfirmationOpen(false);

    if (closeVehicleSchedules && !closeConfirmOnly) {
      onClose(actionMain);
    }
  };

  const checkIfItemDetailsAreOpen = (
    itemsArray: string[],
    currentDetails: any,
  ) => itemsArray.includes(currentDetails?.id);

  const handleSuccess = (
    selectedtableRows: any,
    isVehicleSchedules: boolean,
    isAllTab: boolean,
    filteredItems: string[] = [],
    allItems: string[] = [],
  ) => {
    const itemHasOpenedDetails =
      (detailsData &&
        checkIfItemDetailsAreOpen(selectedtableRows, detailsData)) ||
      (detailsData && checkIfItemDetailsAreOpen(filteredItems, detailsData)) ||
      (detailsData && checkIfItemDetailsAreOpen(allItems, detailsData));

    const hasFilteredItems = filteredItems.length > 0;

    const countOfItemsToApply = hasFilteredItems
      ? filteredItems.length
      : resourceCount;

    const successMessage = isAllTab
      ? t(`Alert##apply all ${actionMain} success`)
      : t(`Alert##apply ${actionMain} success`, {
          resourceCount: countOfItemsToApply,
        });

    const matchingValue = itemHasOpenedDetails ? detailsData?.id : undefined;

    // refreshTableAndUpdateDetails method also deselects all rows
    refreshTableAndUpdateDetails({
      valueInSearchField,
      resourceId: matchingValue,
      successMessage,
      itemHasOpenedDetails,
      getTableItemDetails,
      handleResponse,
      leaveRowsChecked: false,
    });

    handleConfirmCloseDialog(true, false);
  };

  return {
    handleCloseSchedulesMainDialog,
    isCloseDialogConfirmationOpen,
    handleConfirmCloseDialog,
    handleSuccess,
  };
};

export default useSchedulesMainDialog;
